import React, { useState } from 'react';
import { Box, Grid, Button, Typography } from '@mui/material';
import { CheckCircleOutline, RadioButtonUnchecked } from '@mui/icons-material';

export default function InventarioTypeSelector({ onChange, optionLabels = ["Option 1", "Option 2"] }) {
  const [selected, setSelected] = useState(0);

  const handleSelect = (index) => {
    setSelected(index);
    onChange && onChange(optionLabels[index]);
  };

  return (
    <Box sx={{ width: '100%', maxWidth: 420, mx: 'auto' }}>
      <Grid container spacing={3} justifyContent="center">
        {optionLabels.map((opt, idx) => (
          <Grid item xs={6} key={optionLabels[idx]}>
            <Button
              variant="outlined"
              onClick={() => handleSelect(idx)}
              fullWidth
              sx={{
                border: selected === idx ? '2.5px solid primary.main' : '2px solid #e0e0e0',
                color: selected === idx ? 'primary.main' : 'inherit',
                textAlign: "center",
                fontWeight: selected === idx ? "bold" : 500,
                transition: 'all 0.2s',
                display: 'flex',
                flexDirection: 'row',
                gap: 1,
                alignItems: 'center',
                justifyContent: 'center'
              }}
              endIcon={
                selected === idx
                  ? <CheckCircleOutline color="primary" />
                  : <RadioButtonUnchecked sx={{ color: "#bdbdbd" }} />
              }
            >{opt}
{/*              <Typography variant="h6" sx={{ fontWeight: selected === idx ? 700 : 500 }}>
                {opt}
              </Typography>
*/}            </Button>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

